import { render, staticRenderFns } from "./member-table.vue?vue&type=template&id=47aad49c&scoped=true"
import script from "./member-table.vue?vue&type=script&lang=ts"
export * from "./member-table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47aad49c",
  null
  
)

export default component.exports